// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c96576e2","73":"4401d20c","87":"8d691ea9","201":"963e712c","256":"58e9d937","261":"f6a5350f","269":"966083e0","389":"eae110fb","495":"c3739690","773":"de63bd3a","792":"e72ec655","823":"dcf84a1a","917":"9dbfc8dd","921":"8c675ff7","974":"99cae433"}[chunkId] + ".chunk.js";
};